import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Thumbnail from '../../assets/thumbnails/rapid-boost.jpeg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faLock, faPlay } from '@fortawesome/free-solid-svg-icons';
import { courseTitleFormat } from '../../utils';

const PlaylistCourse = ({ item, fullAccess }) => {
  const navigate = useNavigate(); // Hook to programmatically navigate
  const [isExpanded, setIsExpanded] = useState(true); // State to track if lessons are expanded
  const url_path = window.location.pathname.split('/').slice(0, -1).join('/');
  const videoId = window.location.pathname.split('/').pop();

  const highlightedRef = useRef(null); // Ref for the highlighted thumbnail

  // Currently hardcoded section times, ideally this should be stored in the database and retrieved with the course metadata
  // Consider creating a course metadata table in the future
  // Total time for this course is currently 255 minutes, which is 4 hours and 15 minutes, so the section times are estimates based on that total time and the number of videos in each section
  const sectionTimes = {
    'punish-game': 76,
    'neutral-game': 115,
    'edgeguarding': 34,
    'application': 30,
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded); // Toggle the state
  };

  // Scroll the highlighted thumbnail into view
  useEffect(() => {
    if (highlightedRef.current) {
      highlightedRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [videoId]);

  return (
    <div className="d-flex flex-column">
      <div>
        <div className="d-flex justify-content-between m-0 pt-2">
          <p className="m-0">{courseTitleFormat(item.section)}</p>
          {/* Toggle Caret */}
          <div
            className="d-flex justify-content-end align-items-end"
            style={{ cursor: "pointer" }}
            onClick={toggleExpand}
          >
            <FontAwesomeIcon
              icon={isExpanded ? faChevronUp : faChevronDown}
              style={{ fontSize: "18px", color: "#A4A4B7" }}
            />
          </div>
        </div>
        <p className="mb-2">{item.videos.length} lessons, {sectionTimes[item.section]} minutes</p>
      </div>

      {/* Render lessons only if expanded */}
      {isExpanded &&
        item.videos.map((lesson) => (
          <div
            className="d-flex mb-4 align-items-center"
            style={{ height: "100px" }}
            key={lesson.id}
          >
              <div
                className="thumbnail-container"
                ref={lesson.id === videoId ? highlightedRef : null} // Attach ref to the highlighted thumbnail
                style={{
                  border: lesson.id === videoId ? "2px solid #FFCC19" : "none", // Highlight the current video
                  cursor: lesson.free_trial || fullAccess ? "pointer" : "not-allowed", // Set cursor based on free_trial or fullAccess
                }}
                onClick={lesson.free_trial || fullAccess ? () => navigate(`${url_path}/${lesson.id}`) : null}
              >
                <img src={lesson.thumbnail_uri} alt="thumbnail" className={lesson.free_trial || fullAccess ? "thumbnail" : "thumbnail-dark"} />
                {!lesson.free_trial && !fullAccess ? (
                  <span className="lock-icon">
                    <FontAwesomeIcon
                      icon={faLock}
                      style={{ color: "white", width: "20px", height: "20px" }}
                    />
                  </span>
                ) : (
                  <span className="play-icon">
                    <FontAwesomeIcon
                      icon={faPlay}
                      style={{ color: "white", width: "20px", height: "20px" }}
                    />
                  </span>
              
                )}
              </div>
            <div
              className="ms-2 d-flex flex-column justify-content-center"
              style={{ height: "100px" }}
            >
              <p
                className="m-0"
                style={{ color: "#A4A4B7", fontSize: "15px" }}
              >
                Lesson {lesson.sort_order}
              </p>
              <p className="m-0">{lesson.name}</p>
            </div>
          </div>
        ))}
      {/* Straight line */}
      <div
        style={{
          width: "100%",
          height: "1px",
          backgroundColor: "#AEAFBA",
          // marginBottom: "16px",
        }}
      ></div>
    </div>
  );
};

export default PlaylistCourse;